import { useMemo } from "react";
import ProfessionApi from "./professionApi";
import useSessionId from "./useSessionId";

function useProfessionApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new ProfessionApi(sessionId), [sessionId]);
}

export default useProfessionApi;
